import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Breadcrumb2Component } from './breadcrumb2.component';

@NgModule({
	declarations: [Breadcrumb2Component],
	imports: [CommonModule, TranslateModule],
	exports: [Breadcrumb2Component],
})
export class Breadcrumb2Module {}
